<script lang="ts">import { stateUi } from "@infinitro/config";
import JackpotBanner from "./jackpot-banner.svelte";
import StaticBanner from "./static-banner.svelte";
</script>

{#if $stateUi.sidebar.bannerVariant === 'static'}
	<StaticBanner />
{:else if $stateUi.sidebar.bannerVariant === 'jackpot'}
	<JackpotBanner />
{/if}
